/** Convert script lines to the hook, body, CTA and disclaimer frames. */
export function parseScriptToTextFrames(scriptText: string): Array<{
  id: string;
  text: string;
  durationSec: number;
  style: 'question' | 'answer' | 'disclaimer' | 'cta';
}> {
  const lines = scriptText
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean);

  if (lines.length === 0) return [];

  const frames: Array<{
    id: string;
    text: string;
    durationSec: number;
    style: 'question' | 'answer' | 'disclaimer' | 'cta';
  }> = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const lower = line.toLowerCase();
    let style: 'question' | 'answer' | 'disclaimer' | 'cta';

    if (i === 0) {
      style = 'question';
    } else if (
      /\b(book|link in bio|consultation$|book now|dm us|dm me|send a dm|learn more|get started|sign up|contact us|call us|message us)\b/i.test(
        lower
      ) &&
      !/results vary|consultation required/i.test(lower)
    ) {
      style = 'cta';
    } else if (/results vary|consultation required/i.test(lower)) {
      style = 'disclaimer';
    } else {
      style = 'answer';
    }

    frames.push({
      id: `tf-${i}`,
      text: line,
      durationSec: 3, // Nominal — beat-synced timing is used by the video worker
      style,
    });
  }

  return frames;
}
